import React from "react";
import {
  Box,
  Button,
  Chip,
  Container,
  Fade,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { projects } from "../config/projects";
import "../styles/components/ProjectsPage.css";

function Projects() {
  const navigate = useNavigate();

  return (
    <Box>
      <section className="projects-hero">
        <Container>
          <Fade in timeout={1000}>
            <Box textAlign="center">
              <Typography
                variant="h1"
                component="h1"
                gutterBottom
                sx={{
                  fontSize: { xs: "2.5rem", md: "3.5rem" },
                  fontWeight: 700,
                  textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
                }}
              >
                Projects
              </Typography>
              <Typography
                variant="h5"
                sx={{
                  opacity: 0.9,
                  lineHeight: 1.6,
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                A focused look at the kinds of products, interfaces, and
                integrations I build.
              </Typography>
            </Box>
          </Fade>
        </Container>
      </section>

      <Container sx={{ py: { xs: 4, md: 8 } }}>
        <Grid
          container
          rowSpacing={{ xs: 2, sm: 4 }}
          columnSpacing={{ xs: 0, sm: 4 }}
        >
          {projects.map((project) => (
            <Grid item xs={12} sm={6} lg={3} key={project.title}>
              <Paper className="project-card" elevation={2}>
                <div
                  className="project-card-accent"
                  style={{ backgroundColor: project.accent }}
                />
                <Typography
                  variant="overline"
                  component="p"
                  sx={{ color: project.accent, fontWeight: 700 }}
                >
                  {project.category}
                </Typography>
                <Typography
                  variant="h5"
                  component="h2"
                  sx={{
                    fontWeight: 700,
                    lineHeight: 1.25,
                    overflowWrap: "anywhere",
                  }}
                >
                  {project.title}
                </Typography>
                <Typography color="text.secondary" sx={{ mt: 2, lineHeight: 1.7 }}>
                  {project.summary}
                </Typography>
                <Typography sx={{ mt: 3, fontWeight: 600 }}>
                  {project.impact}
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 3 }}>
                  {project.stack.map((item) => (
                    <Chip key={item} label={item} size="small" />
                  ))}
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Paper className="projects-next-step" elevation={0}>
          <Box>
            <Typography variant="h4" component="h2" sx={{ fontWeight: 700 }}>
              Have a project in mind?
            </Typography>
            <Typography color="text.secondary" sx={{ mt: 1 }}>
              Share the workflow, product idea, or integration you want to
              build and I can help shape the path from idea to launch.
            </Typography>
          </Box>
          <Button
            variant="contained"
            endIcon={<ArrowForward />}
            onClick={() => navigate("/contact")}
            sx={{ backgroundColor: "#0066CC", flexShrink: 0 }}
          >
            Start a Conversation
          </Button>
        </Paper>
      </Container>
    </Box>
  );
}

export default Projects;
